/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Highpriority1Inputs */

const de__field_highpriority1 = /** @type {(inputs: _Field_Highpriority1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hohe Priorität`)
};

/**

* @param {_Field_Highpriority1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_highpriority1 = /** @type {((inputs?: _Field_Highpriority1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Highpriority1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_highpriority1(inputs)
});
export { _field_highpriority1 as "_field_highPriority" }